/* eslint-disable no-unused-vars */
import {
	Badge,
	HStack,
	IconButton,
	StackProps,
	Text,
	VStack,
	Spacer,
	Button,
	useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { GiUpgrade } from "react-icons/gi";
import { EventLog } from "../../../pages/mob_mountain";
import { Raider } from "../../../types/raider";
import { nameCleanup } from "../../../util/helpers";
import { MountainParamsType } from "../layouts/RaiderCardLayout";
import RecruitButton from "./RecruitButton";
import { FiMap } from "react-icons/fi";
import {GiRoundBottomFlask} from "react-icons/gi";

type openFunc = (raider: Raider, index: number) => void;
type openBareFunc = (raider: Raider) => void;

interface UserInfoProps extends StackProps {
	raider: Raider;
	openLeftPane: openFunc;
	button: string;
	openQuestPane: openBareFunc;
	openAlchemyPane: openBareFunc;
	openStatusPane: openBareFunc;
	hide_button: boolean;
	mountainParams?: MountainParamsType
}

export const RaiderInfo = (props: UserInfoProps) => {
	const { raider, openLeftPane, ...stackProps } = props;
	const [button, setButton] = useState<JSX.Element>();
	const [eventsToRaider, setEventsToRaider] = useState<Record<number, EventLog>>({})
	const toast = useToast();

	const buttonResolver = () => {
		if (props.button == "mountain") {
		  if (props.mountainParams?.allRunners.includes(Number(raider.id))) {
			const event = eventsToRaider[Number(raider.id)]
			if (event) {
			  return(<Text fontSize={'small'} textAlign='center' color={["none", "green", "yellow", "red"][event[3]]}>
				RUN: {["NONE", "Success!", "Failed, gem stolen by mob.", "Died!"][event[3]]}
			  </Text>)
			} else {
			  return (<Text fontSize={'small'} textAlign='center'>
				Waiting...
			  </Text>)
			}
		  } else {
			if (props.mountainParams?.approved) {
				if (!props.mountainParams?.currentRunners.includes(Number(raider.id))) {
					return (
						<Button
						  colorScheme="gray"
						  width="full"
						  onClick={() => props.mountainParams?.mountainAction(Number(raider.id))}
						>
						  Run
						</Button>
					  )
				} else {
					return (<Text fontSize={'small'} textAlign='center'>
					Running!...
				  </Text>)
				}
			} else {
			  return (
				<Button
				  colorScheme="gray"
				  width="full"
				  onClick={() => props.mountainParams?.approveAction()}
				>
				  {props.mountainParams?.isApproving ? "Please wait.." : "Approve Raiders"}
				</Button>
			  )
			}
		  }
		}
		else if (props.button == "recruit") {
		  return <RecruitButton raider={raider} toast={toast} />
		} else if (props.button == "quest-status") {
		  return (
			<Button
			  rightIcon={<FiMap />}
			  colorScheme="gray"
			  width="full"
			  onClick={() => props.openStatusPane(raider)}
			>
			  Quest Status
			</Button>
		  )
		} else if (props.button == "quests") {
		  return (
			<Button
			  rightIcon={<FiMap />}
			  colorScheme="gray"
			  width="full"
			  onClick={() => props.openQuestPane(raider)}
			>
			  Quests
			</Button>
		  )
		} else if (props.button == "alchemy") {
		  return (
			<Button
			  rightIcon={<GiRoundBottomFlask />}
			  colorScheme="gray"
			  width="full"
			  onClick={() => props.openAlchemyPane(raider)}
			>
			  Alchemy
			</Button>
		  )
		} else {
			console.log("no button!!")
		}
	  }

	useEffect(() => {
		const newButton = buttonResolver();
		setButton(newButton);
	}, [
		props.mountainParams?.allRunners,
		props.mountainParams?.approved,
		props.mountainParams?.isApproving, 
		props.mountainParams?.approved, 
		props.mountainParams?.currentRunners
	])

	useEffect(() => {
		const newButton = buttonResolver();
		setButton(newButton);
	}, [eventsToRaider])

	useEffect(() => {
		const newHash = {} as Record<number, EventLog>;
		props.mountainParams?.eventLogs.forEach(log => {
			newHash[Number(log[1])] = log;
		})
		setEventsToRaider(newHash);
		const newButton = buttonResolver();
		setButton(newButton);
	},[props.mountainParams?.eventLogs])

	return (
		<div>
		<VStack spacing="4" flex="1" {...stackProps} align="left">
			<VStack spacing="1" flex="1" align="left">
				<Text fontWeight="bold">{nameCleanup(raider.name)}</Text>
				<HStack mb={2}>
					<Badge variant="outline">lvl. {raider.attributes[1].value}</Badge>
					<Badge variant="outline">gen. {raider.attributes[3].value}</Badge>
					<Badge variant="outline">Id: {raider.id}</Badge>
					<Spacer />
					{!props.hide_button && (
						<IconButton
							aria-label="Raider"
							icon={<GiUpgrade />}
							variant="outline"
							onClick={() => openLeftPane(raider, 0)}
						/>
					)}

				</HStack>
			</VStack>
			{/* <Progress
				hasStripe
				value={(raider.xp / levelRamp(raider.xp)[1]) * 100}
				width="100%"
			>
				<Text className="progress-label">{raider.xp}xp</Text>
			</Progress> */}
		</VStack>
		{button}
		</div>
	);
};
